import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=a8b89132&lang=pug&"
import script from "./CustomFields.vue?vue&type=script&lang=js&"
export * from "./CustomFields.vue?vue&type=script&lang=js&"
import style0 from "./CustomFields.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports